import { useAssetFieldBindings } from "@Client/@Composables/application-standalone/pages/assets/useAssetFieldBindings";
import { useAssetFieldVisibility } from "@Client/@Composables/application-standalone/pages/assets/useAssetFieldVisibility";
export const assetsPageBindingsAndVisibilities = (applicantIndex, assetIndex, applicantId) => {
  const {
    assetType,
    assetDescription,
    assetAmount,
    assetOwner
  } = useAssetFieldBindings({
    applicantIndex,
    assetIndex
  });
  const {
    assetTypeVisible,
    assetDescriptionVisible,
    assetAmountVisible
  } = useAssetFieldVisibility({
    applicantIndex,
    assetIndex,
    applicantId
  });
  return {
    bindings: {
      assetType,
      assetDescription,
      assetAmount,
      assetOwner
    },
    visibilities: {
      assetTypeVisible,
      assetDescriptionVisible,
      assetAmountVisible
    }
  };
};